export default "__VITE_ASSET__Dn38pf2g__"